export default __webpack_public_path__ + "static/media/GA.d116d794.svg";